import React from 'react';
import './styles.scss';

const Tabs = ({ item, handleTabSelect, isActive, index }) => {
  const { shortName, totalPackageCount } = item;
  const activeState = isActive ? 'active' : '';
  const disabledState = totalPackageCount === 0 ? 'disabled' : '';
  return (
    <li className={`${activeState} ${disabledState}`} onClick={() => handleTabSelect(item, index)}>
      <span className="name">{shortName}</span>
      <span className="packCount">&nbsp;({totalPackageCount})</span>
    </li>
  );
};
export default Tabs;
